import { useFretboardConfigStore } from '@/features/fretboard-base';
import React from 'react';

export const FretSpacingSelector: React.FC = () => {
  // This assumes you'll add this property to your store
  const useEqualTemperament = useFretboardConfigStore((state) => state.useEqualTemperament);
  const setUseEqualTemperament = useFretboardConfigStore((state) => state.setUseEqualTemperament);

  const handleChange = () => {
    setUseEqualTemperament(!useEqualTemperament);
  };

  return (
    <div className="form-control w-full mb-3 max-w-full">
      <label className="label">
        <span className="label-text">Fret Spacing</span>
      </label>
      <div className="flex items-center justify-between">
        <span className="text-sm opacity-70">
          {useEqualTemperament ? '12-TET Spacing' : 'Regular Spacing'}
        </span>
        <input
          type="checkbox"
          className="toggle toggle-primary"
          checked={useEqualTemperament}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};
